import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import SectionHeading from './components/SectionHeading.vue'
import SectionSubheading from './components/SectionSubheading.vue'

import '@fontsource/roboto-condensed'
import '@fontsource/anton'

library.add(faArrowRight)
global.RS_WRITE_KEY = process.env.VUE_APP_WRITE_KEY
global.RS_DATA_PLANE_URL = process.env.VUE_APP_DATA_PLANE_URL

createApp(App)
  .use(router)
  .component('font-awesome-icon', FontAwesomeIcon)
  .component('SectionHeading', SectionHeading)
  .component('SectionSubheading', SectionSubheading)
  .mount('#app')
